import { Cpu, MapPin, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

function About() {
  const navigate = useNavigate();

  return (
    <div className="bg-black text-white min-h-screen px-6 md:px-10 lg:px-20 py-20 max-w-[1400px] mx-auto">

      {/* 🔥 HERO SECTION */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-16">

        {/* LEFT TEXT */}
        <motion.div
          className="flex-1"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-green-400 text-xs tracking-[0.2em] mb-4">
            OUR MISSION
          </p>

          <h1 className="text-4xl md:text-6xl font-bold leading-[1.1]">
            Engineering the <br />
            <span className="text-green-400">Future of Printing</span>
          </h1>

          <p className="text-gray-400 mt-6 max-w-xl leading-relaxed">
            Printezz is an automated printing ecosystem designed to bridge the
            gap between digital documents and instant physical prints with speed,
            security, and simplicity.
          </p>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="flex-1 flex justify-center md:justify-end"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="bg-[#0a0a0a] p-6 rounded-2xl border border-green-400/10 
          shadow-[0_0_60px_#00ff9f25] w-[280px] md:w-[350px] lg:w-[420px] mt-20
          hover:scale-105 transition duration-500">

            <img
              src="/assests/printer.png"
              alt="machine"
              className="w-full object-contain"
            />

          </div>
        </motion.div>

      </div>

      {/* 🔥 2 CARDS */}
      <motion.div
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="grid md:grid-cols-2 gap-8 mt-24 max-w-5xl mx-auto">

          <div className="bg-[#020617] p-8 rounded-2xl border border-green-400/10 
          hover:scale-105 transition duration-300 group">
            <h3 className="text-xl font-semibold mb-3 group-hover:text-green-400">
              The Current Struggle
            </h3>
            <p className="text-gray-400">
              Long queues, broken printers, and complex setups.The traditional
              printing experience outdated, unreliable and frustrating for modern professionals.
            </p>
          </div>

          <div className="bg-green-400/5 p-8 rounded-2xl border border-green-400/20 
          hover:scale-105 transition duration-300 group">
            <h3 className="text-xl font-semibold mb-3 text-green-400">
              The PrintEZ Way
            </h3>
            <p className="text-gray-300">
              Instant, IoT-enabled Vending machine available 24/7. We've simplified the entire process to a single tap, bringing efficiency to your neighborhood.
            </p>
          </div>

        </div>
      </motion.div>

      {/* 🔥 QUOTE SECTION */}
      <motion.div
        className="mt-28 flex flex-col md:flex-row items-center justify-center gap-14"
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >

        {/* <div className="bg-[#020617] p-4 rounded-2xl border border-green-400/10 
        shadow-[0_0_40px_#00ff9f20] hover:rotate-1 transition duration-300">
          <img
            src="/assests/abhinavsinghnew.jpeg"
            alt="founder"
            className="w-[220px] rounded-xl"
          />
        </div> */}

         <div className="max-w-xl">
          <p className="text-xl text-gray-300 leading-relaxed">
            “As an engineer, We saw a system that was stuck in the past.
            PrintEZ wasn't just built to print paper, it is engineered to
            solve Big Printing problems using modern technology and user-centric design.”
          </p>

          {/* <div className="mt-6 border-l-2 border-green-400 pl-4">
            <p className="text-green-400 font-semibold">
              Co-Founder
            </p>
            <p>
              Abhinav Singh
            </p>
            <p className="text-gray-500 text-sm">
              The Visionary Behind PrintEZ
            </p>
          </div> */}
        </div> 

      </motion.div>

      {/* 🔥 FEATURES */}
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-28"
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >

        <div className="bg-[#020617] p-6 rounded-2xl border border-green-400/10 hover:scale-105 transition duration-300">
          <Cpu className="text-green-400 mb-3" />
          <h4 className="font-semibold text-lg">Precision</h4>
          <p className="text-gray-400 mt-2 text-sm">
            Engineered for 100% reliability. Our hardware undergoes rigorous stress testing to ensure every print is perfect.
          </p>
        </div>

        <div className="bg-[#020617] p-6 rounded-2xl border border-green-400/10 hover:scale-105 transition duration-300">
          <MapPin className="text-green-400 mb-3" />
          <h4 className="font-semibold text-lg">Accessibility</h4>
          <p className="text-gray-400 mt-2 text-sm">
            Automated vending machine in every corner of the city.We believe essential services should be within a 5-minutes walk.
          </p>
        </div>

        <div className="bg-[#020617] p-6 rounded-2xl border border-green-400/10 hover:scale-105 transition duration-300">
          <Sparkles className="text-green-400 mb-3" />
          <h4 className="font-semibold text-lg">Innovation</h4>
          <p className="text-gray-400 mt-2 text-sm">
            A female-led intensive pushing the boundaries of traditional services throungh diverse engineering prespectives.
          </p>
        </div>

      </motion.div>

      {/* 🔥 TECH STACK */}
      <motion.div
        className="mt-28 bg-[#020617] border border-green-400/10 rounded-2xl p-10 text-center shadow-[0_0_50px_#00ff9f10]"
        initial={{ scale: 0.9, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >

        <h2 className="text-2xl md:text-3xl font-semibold">
          Built on a robust, scalable stack
        </h2>

        <p className="text-gray-400 mt-3">
          Ensuring your data stays secure and prints stay crisp.
        </p>

      </motion.div>

      {/* 🔥 CTA SECTION */}
      <motion.div
        className="mt-28 bg-[#020617] border border-green-400/10 rounded-2xl p-10 md:p-16 text-center shadow-[0_0_60px_#00ff9f10]"
        initial={{ scale: 0.9, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >

        <h2 className="text-2xl md:text-3xl font-semibold text-white">
          Ready to experience the future?
        </h2>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">

          <button onClick={() => window.open("https://app.printezz.com/", "_blank")} className="px-6 py-3 bg-black text-white rounded-full border border-green-400 hover:bg-green-400 hover:text-black transition duration-300 shadow-[0_0_20px_#00ff9f30]">
            Nearby printEZ Satation
          </button>

          <button
            onClick={() => navigate("/contact")}
            className="px-6 py-3 bg-white text-black rounded-full hover:bg-green-400 hover:text-black transition duration-300"
          >
            Contact Us
          </button>

        </div>

      </motion.div>

    </div>
  );
}

export default About;